// extracted by mini-css-extract-plugin
module.exports = {"container":"PolicyUpdatePage_container__1rh_7","buttons":"PolicyUpdatePage_buttons__3XHPT","header":"PolicyUpdatePage_header__2Pagz","help":"PolicyUpdatePage_help__PiOHQ"};